export default "__VITE_ASSET__CuM7_k8t__"